<template>
  <ItemDetailField
    :label="label"
    :help="description"
    :readonly="readOnly"
    :is-editing="isEditing"
  >
    <div class="annotation-row">
      <FieldComponent
        class="control is-expanded"
        :field-meta="fieldMeta"
        :data="annotation"
        :is-edit-mode="isEditing"
        @edit="(value) => $emit('edit', value)"
      />
      <template v-if="isEditing">
        <div v-if="hasEdits" class="control">
          <button
            v-tooltip="'Save edits'"
            class="button is-primary"
            @click="$emit('save')"
          >
            <span class="icon is-small">
              <i class="fa-solid fa-save fa-xs" />
            </span>
          </button>
        </div>
        <template v-if="!readOnly">
          <div v-if="hasEdits" class="control">
            <button
              v-tooltip="'Cancel edits'"
              class="button"
              @click="$emit('cancel')"
            >
              <span class="icon is-small">
                <i class="fa-solid fa-undo fa-xs" />
              </span>
            </button>
          </div>
          <IconButton
            v-else
            class="annotation-delete-btn"
            icon="fa-solid fa-trash"
            color="danger"
            size="small"
            tooltip="Remove annotation"
            @click="$emit('delete')"
          />
        </template>
      </template>
    </div>
  </ItemDetailField>
</template>

<script>
import ItemDetailField from '@/components/fields/ItemDetailField.vue'

export default {
  name: 'AnnotationListItem',
  components: { ItemDetailField },
  props: {
    annotation: Object,
    fieldMeta: Object,
    isEditing: Boolean,
    hasEdits: Boolean,
  },
  computed: {
    label() {
      const fallbackLabel =
        this.annotation.name || this.fieldMeta.name || this.metaview.name
      return this.fieldMeta.label || fallbackLabel
    },
    description() {
      return this.fieldMeta.description
    },
    readOnly() {
      return this.fieldMeta.readonly
    },
  },
}
</script>

<style lang="scss" scoped>
.annotation-row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.annotation-delete-btn {
  font-size: 0.85em;
}
</style>
